import { ca } from '@cian/analytics';

export type TLabel =
  | 'RoomTour/Livingroom'
  | 'RoomTour/Bedroom'
  | 'RoomTour/Kitchen'
  | 'RoomTour/Hallway'
  | 'RoomTour/JK'
  | 'RoomTour/MorePhoto';

export function trackAnchorsClick(option: TLabel) {
  ca('eventSite', {
    action: 'Click',
    category: 'card',
    label: option,
    useLastProducts: true,
  });
}
